import { useState } from 'react';
import { Trans } from '@lingui/react/macro';
import { Box } from '@pocketlaw/tetris';
import { useFileBrowserContext } from 'app/domains/filesystem';
import { useTemplateBrowserContext } from 'app/domains/templates';
import { ToggleTabs, ToggleTabsButton, ToggleTabsButtonsContainer, ToggleTabsContent } from 'shared/domains/common-ui';
import { PickerBreadcrumbs } from '../PickerBreadcrumbs';
import { PickerDialog } from '../PickerDialog';
import { PickerFooter } from '../PickerFooter';
import { PickerHeader } from '../PickerHeader';
import { PickerTableFilesystem } from '../PickerTableFilesystem';
import { PickerTableTemplates } from '../PickerTableTemplates';
export function FileTemplateDialog(props) {
    const { dialogTitle, dialogSubtitle, submitLabel, selectedEntryAlert, onClose, onSubmitDocument, onSubmitTemplate } = props;
    const { fileBrowserSearch, selected } = useFileBrowserContext();
    const { templateBrowserSearch, selectedTemplateId } = useTemplateBrowserContext();
    const [activeTab, setActiveTab] = useState('filesystem');
    const isDocumentTab = activeTab === 'filesystem';
    const toggleTabsSpacing = activeTab === 'filesystem' ? 'xl' : '2xl';
    const [selectedEntry] = selected || [];
    const selectedEntryId = selectedEntry === null || selectedEntry === void 0 ? void 0 : selectedEntry.id;
    const submitDisabled = (activeTab === 'filesystem' && !selectedEntryId) || (activeTab === 'templates' && !selectedTemplateId);
    const searchQuery = isDocumentTab ? fileBrowserSearch.searchQuery : templateBrowserSearch.searchQuery;
    const handleSearch = (query) => {
        if (isDocumentTab) {
            fileBrowserSearch.search(query);
        }
        else {
            templateBrowserSearch.search(query);
        }
    };
    const handleClearSearch = () => {
        if (isDocumentTab) {
            fileBrowserSearch.clearSearch();
        }
        else {
            templateBrowserSearch.clearSearch();
        }
    };
    const handleSubmit = () => {
        if (isDocumentTab) {
            onSubmitDocument();
        }
        else {
            onSubmitTemplate();
        }
    };
    return (<PickerDialog>
      <PickerHeader title={dialogTitle} subtitle={dialogSubtitle} onClose={onClose} search={handleSearch} searchQuery={searchQuery} clearSearch={handleClearSearch}/>
      <ToggleTabs activeTab={activeTab} onSelectTab={setActiveTab}>
        <Box pl="2xl" pr="2xl" pb={toggleTabsSpacing}>
          <ToggleTabsButtonsContainer stretch size="small">
            <ToggleTabsButton tabKey="filesystem">
              <Trans comment="Documents label">Documents</Trans>
            </ToggleTabsButton>
            <ToggleTabsButton tabKey="templates">
              <Trans comment="Templates label">Templates</Trans>
            </ToggleTabsButton>
          </ToggleTabsButtonsContainer>
        </Box>
        <ToggleTabsContent tabKey="filesystem">
          <PickerBreadcrumbs />
          <PickerTableFilesystem selectedEntryAlert={selectedEntryAlert}/>
        </ToggleTabsContent>
        <ToggleTabsContent tabKey="templates">
          <PickerTableTemplates />
        </ToggleTabsContent>
      </ToggleTabs>
      <PickerFooter showPagination={isDocumentTab} submitLabel={submitLabel} disabled={submitDisabled} onSubmit={handleSubmit}/>
    </PickerDialog>);
}
